import Constants from '../constants/action'
import { api } from '../utils/api'
import { sortString } from '../views/helpers'

const Actions = {
  updateSelectedOrderRequest: id => dispatch => {
    new Promise((resolve, reject) => {
      updateSelectedOrderRequest(id, resolve, reject, dispatch)
    }).then(
      ({ orderRequest }) => {
        dispatch({
          type: Constants.UPDATE_SELECTED_ORDER_REQUEST,
          orderRequest,
        })
      },
      () => {}
    )
  },

  setFilterParams: (filterParams, sortBy, sortAsc) => dispatch => {
    dispatch({
      type: Constants.SET_FILTER_PARAMS,
      filterParams: {
        ...filterParams,
        sort:
          sortBy && typeof sortAsc === 'boolean'
            ? sortString(sortBy, sortAsc)
            : filterParams.sort,
      },
      sortBy,
      sortAsc,
    })
  },

  cancelSelectedOrderRequest: orderRequestId => dispatch => {
    api
      .request('post', `order_requests/${orderRequestId}/cancel`, dispatch)
      .then(() => {
        dispatch(Actions.updateSelectedOrderRequest(orderRequestId))
      })
      .catch(() => {
        // catch it but just ignore any errors
      })
  },

  selectOrderRequest: (orderRequestId, included) => dispatch => {
    api.get(`b2b/order_requests/${orderRequestId}`, dispatch).then(response => {
      dispatch({
        type: Constants.UPDATE_SELECTED_ORDER_REQUEST,
        orderRequest: response.data,
      })
    })

    dispatch({ type: Constants.SELECTED_ORDER_REQUEST_BREAKDOWN_FETCHING })
    api
      .get(`b2b/order_requests/${orderRequestId}/breakdown`, dispatch)
      .then(response => {
        dispatch({
          type: Constants.SELECTED_ORDER_REQUEST_BREAKDOWN,
          breakdown: response.data,
        })
      })
  },

  clearSelectedOrderRequest: () => dispatch => {
    dispatch({
      type: Constants.CLEAR_SELECTED_ORDER_REQUEST,
    })
  },

  getGoodsInfoImages: goodsInfoId => dispatch =>
    api
      .get(`b2b/goods_information/${goodsInfoId}/images`, dispatch)
      .then(response => {
        dispatch({
          type: Constants.SET_GOODS_INFORMATION_IMAGES,
          images: response.data,
        })
      }),

  toggleOpenDetail: () => dispatch => {
    dispatch({
      type: Constants.TOGGLE_OPEN_DETAIL,
    })
  },

  toggleOpenSignature: () => dispatch => {
    dispatch({
      type: Constants.TOGGLE_OPEN_SIGNATURE,
    })
  },

  toggleOpenPreview: () => dispatch => {
    dispatch({
      type: Constants.TOGGLE_OPEN_PREVIEW,
    })
  },
}

export default Actions
